import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { MasterCardLeafCollectionReport } from './Pages';

export const MasterCardLeafCollectionReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={MasterCardLeafCollectionReport} />
    </Fragment>
)